import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/bootstrap-vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import VueMask from 'v-mask'
Vue.config.productionTip = false

Vue.use(VueMask);
Vue.use(require('vue-shortkey'))
new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
